<template>
  <v-list flat light>
    <v-list-item>
      <v-text-field
        v-model="search"
        label="Buscar menu"
        hide-details="auto"
      ></v-text-field>
    </v-list-item>

    <template v-for="(item, id) in menuComputed">
      <v-list-item
        v-if="item.childrens === null"
        :key="`menu-item-${id}`"
        :to="item.to"
      >
        <i :class="item.icon"></i>{{ item.label }}
      </v-list-item>
      <v-subheader v-else-if="item.separator" :key="`menu-separator-${id}`">
        {{ item.label }}
      </v-subheader>

      <v-list-group v-if="item.to === null" :key="`menu-group-${id}`">
        <template v-slot:activator>
          <v-list-item-title>
            <i :class="item.icon"></i>{{ item.label }}
          </v-list-item-title>
        </template>

        <template>
          <v-list-item
            v-for="(itens, key) in item.childrens"
            :to="itens.to"
            :key="`menu-item-${key}`"
          >
            <v-list-item-title>
              <i :class="itens.icon"></i>{{ itens.label }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
const items = [
  {
    to: { name: "Home" },
    icon: "fas fa-home",
    label: "Dashboard",
    allowed: null,
    childrens: null,
  },
  {
    to: { name: "cashregister" },
    icon: "fas fa-cash-register",
    label: "Faturamento / Caixa",
    allowed: null,
    childrens: null,
  },
  {
    to: { name: "inventory" },
    icon: "fas fa-boxes",
    label: "Estoque",
    allowed: null,
    childrens: null,
  },
  {
    separator: true,
    label: "Cadastros",
  },
];

import { mapGetters, mapMutations } from "vuex";
export default {
  name: "UiMenuPage",
  data() {
    return {
      search: "",
      menuItems: [],
    };
  },
  mounted() {
    setTimeout(() => {
      this.menuItems = [...items];
    }, 200);
  },
  computed: {
    ...mapGetters({
      userSuper: "userSuper",
    }),
    menuComputed() {
      let menu = [];

      this.menuItems.map((e) => {
        if (e.allowed) {
          if (this.permissions(e.allowed) === "S") {
            if (this.search) {
              let label = e.label.toLowerCase();
              if (label.includes(this.search.toLowerCase())) menu.push(e);
            } else {
              menu.push(e);
            }
          }
        } else {
          if (this.search) {
            if (e.label.includes(this.search)) menu.push(e);
          } else {
            menu.push(e);
          }
        }
      });

      return menu;
    },
  },

  methods: {
    ...mapMutations({
      clear: "CLEAR_FRANCHISE",
    }),

    clearFranchise() {
      this.clear();
    },
  },
};
</script>

<style scoped>
i.fas {
  display: inline-block;
  width: 35px;
  text-align: center;
}
</style>
